import print from 'vue3-print-nb'
import permission from './permission'

export default app => {
  app.use(print)
  // 自定义指令
  app.directive('permission', permission)
}
